<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
        :getOptionLabel="getOptionLabel"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på fraktsätt</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import NtapsServiceTypesRepository from '@services/repositories/NtapsServiceTypesRepository';

export default {
    name: 'NtapsServiceTypeFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
        getOptionLabel: {
            type: Function,
            default(opt) {
                if (opt.ui_json && opt.ui_json.name) {
                    return opt.ui_json.name;
                }
                return opt.name;
            },
        },
    },
    data() {
        return {
            options: [],
        };
    },
    async created() {
        const typesRpository = new NtapsServiceTypesRepository();
        typesRpository.getAll().then((response) => {
            const types = [];
            const added = [];

            const postnord = response.find((s) => s.id === 3);
            if (postnord && Array.isArray(postnord.service_types)) {
                postnord.service_types.forEach((type) => {
                    type.delivery_service_id = postnord.id;
                    if (!added.includes(type.name)) {
                        types.push(type);
                        added.push(type.name);
                    }
                });
            }

            response.forEach((service) => {
                if (Array.isArray(service.service_types)) {
                    service.service_types.forEach((type) => {
                        type.delivery_service_id = service.id;
                        if (!added.includes(type.name)) {
                            types.push(type);
                            added.push(type.name);
                        }
                    });
                }
            });

            this.options = types;
        });
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>
